import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Project.css";

class Project extends Component {
  render() {
    const { project, index } = this.props;
    const workNumber = index + 1;
    const MAXLEN = 100;
    const cutDescription =
      project.description.length > MAXLEN
        ? project.description.substring(0, MAXLEN) + "..."
        : project.description;

    return (
      <div className="slide">
        <div className="content">
          <Link to={`/works/` + project.slug} className="clicktarget" />
          <div className="inner-content">
            <Link to={`/works/` + project.slug} className="title">
              {project.title}
            </Link>
            <div className="short">{cutDescription}</div>
          </div>
          <div className="right-line-wrapper">
            <div className="right-line" />
            <div className="project-index">{workNumber < 10 ? "0" + workNumber : workNumber}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project.js